import React from 'react';
import classnames from 'classnames';
import { Props as IconProps } from '@wix/da-ds/pkg/Icons/IconWrap';
import RadioButton from '@wix/da-ds/pkg/RadioButton';

import s from './LayoutRadioButton.scss';

interface Props {
  label: string;
  value: string;
  onChange: any;
  icon: React.ComponentType<IconProps>;
  checked?: boolean;
}

const LayoutRadioButton: React.FC<Props> = ({
  label,
  value,
  onChange,
  icon: Icon,
  checked = false,
}) => (
  <RadioButton
    name="layout"
    value={value}
    onChange={onChange}
    checked={checked}
    className={classnames(s['root'], checked && s['checked'])}
    inputClassName={s['input']}
    size="small"
    withMargins
  >
    <Icon className={s['icon']} disableDefaultColors />
    <span className={s['label']}>{label}</span>
  </RadioButton>
);

export default LayoutRadioButton;
